import { Injectable } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { MapService } from 'src/app/shared/components/map/map.service';
import { MenuPopupService } from 'src/app/shared/components/menus/menu-popup/menu-popup.service';
import { LayerMenuComponent } from '../../layer-menu/layer-menu.component';
import { MapAction } from '../map-action';

@Injectable({
  providedIn: 'root'
})
export class MenuEventService extends MapAction {

  top: number;
  left: number;

  constructor(
    mapService: MapService,
    private menuPopupService: MenuPopupService
  ) {
    super();
    mapService.map$.subscribe(m => this.listen(m));
  }

  private listen(mapbox: mapboxgl.Map) {

    mapbox.on('contextmenu', (e) => {
      if (this.active) {
        this.action(mapbox, e);
      }
    });

    mapbox.on('click', (e) => {
      if (this.active) {
        this.top = e.originalEvent.clientY;
        this.left = e.originalEvent.clientX;
        this.menuPopupService.close();
      }
    });
  }

  private action(mapbox: mapboxgl.Map, e: mapboxgl.MapMouseEvent) {
    const top = e.originalEvent.clientY;
    const left = e.originalEvent.clientX;
    const component = LayerMenuComponent;
    const data = [e.lngLat.lng, e.lngLat.lat];
    this.menuPopupService.open({ component, left, top, data });
  }

}
